var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chart--bubble_svg__clip0_61530_7426)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5H3A1.5 1.5 0 011.5 21V1.5H3V21h19.5v1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-1.5a3 3 0 100 6 3 3 0 000-6zM15.75 4.5a3 3 0 110 6 3 3 0 010-6zm0-1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM18.375 15.75a1.125 1.125 0 110 2.25 1.125 1.125 0 010-2.25zm0-1.5a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chart--bubble_svg__clip0_61530_7426"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgChartBubble;